export default {
    getTokenFromURL: () => {
        return window.location.hash.substring(1).split('&')[0] || decodeURIComponent(photoOrg.Util.getURLParameter("token"));
    }

}
export const saveImageModelForDetailView = (model)=>{
    var p = new photoOrg.pict(model);
    //below format is required for detail view & populate thumbnails in detail view
    p.set('id', model.assetId);
    p.width = (model.width|| 200);
    p.height = (model.height || 200);
    p.attributes.ownerAccountId= model.ownerId
    p.attributes.files= [{
        "fileType" : "THUMBNAIL",
        "height" : p.height,
        "url" : p.get("thumbnailEncryption"),
        "width" :p.width
    }]
    p.attributes.userTags=[]
    p.attributes.systemTags=[]
    photoOrg.photoLib.UserAssetsInfo.singleAlbumsAssets.add(p);

}